"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const maps_api_1 = require("maps-api");
const react_1 = __importStar(require("react"));
const tech_1 = require("../../../tech");
const constants_1 = require("../../constants");
const projection_1 = require("../../projection");
const LauProvider_1 = require("../LauProvider");
const MapControlsLayout_1 = require("../MapControlsLayout");
const Panorama_1 = __importDefault(require("../Panorama/Panorama"));
const mapViewObject = (0, maps_api_1.createMap)({
    projection: projection_1.projection
});
// States has type of MapVIewProps.states
function getStateDataForLoadFunction(states, index) {
    return Object.assign({}, ...states.map((state) => state.data));
}
/**
 * MapView component for rendering pasport map on whole screen
 * @param apiStates - array of api states with marker data
 * @param dataProcess - array of functions for processing data from api states
 * @param usePanorama - flag for using panorama, default is false
 * @param defaultPanoramaPhoto - default photo for panorama, path in public folder
 * @param children - presents legend for map
 */
function MapView(props) {
    // Create map object
    const [MapContainer, map] = (0, maps_api_1.useMap)(mapViewObject, {
        onLoad: (map) => {
            map.map.on("click", () => {
                window.dispatchEvent(new Event(constants_1.CLOSE_ALL_POPUPS_EVENT));
            });
        }
    });
    // Create olygon for LAU
    const [lauPolygon, setLauPolygon] = react_1.default.useState();
    // Save layers object to be processed in legend
    const [layers, setLayers] = react_1.default.useState();
    // Panorama state
    const { state: panoramaState, add: addPanoramas } = (0, tech_1.usePanoramas)(Boolean(props.usePanorama));
    // Create apiStates object, which can contain panorama too
    const apiStates = (0, react_1.useMemo)(() => {
        return [...props.apiStates, panoramaState];
    }, [props.apiStates, props.usePanorama]);
    const dataProcess = (0, react_1.useMemo)(() => {
        if (!props.usePanorama)
            return props.dataProcess;
        return [...props.dataProcess, addPanoramas];
    }, [props.dataProcess, props.usePanorama]);
    const statesAreReady = (0, react_1.useMemo)(() => {
        return !apiStates.find((state) => state.loading || state.error || !state.success);
    }, [apiStates]);
    (0, react_1.useEffect)(() => {
        if (!statesAreReady)
            return;
        const layers = dataProcess.map((load, index) => load(map, getStateDataForLoadFunction(apiStates, index)));
        const layersObject = Object.assign({}, ...layers);
        setLayers(layersObject);
        return () => {
            Object.values(layersObject).forEach((layer) => {
                if (layer instanceof maps_api_1.MarkerLayer) {
                    layer.delete();
                }
            });
        };
    }, [statesAreReady]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "h-100", children: [(0, jsx_runtime_1.jsx)(LauProvider_1.LauContainer, { map: map, setPolygon: setLauPolygon, children: (0, jsx_runtime_1.jsx)(MapContainer, { children: (0, jsx_runtime_1.jsx)(MapControlsLayout_1.MapControlsLayout, { map: map, lauPolygon: lauPolygon, hideLegend: !statesAreReady, legendRender: () => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children && statesAreReady && layers && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children(map, layers) })) })) }) }) }), props.usePanorama && ((0, jsx_runtime_1.jsx)(Panorama_1.default, { panoramaState: panoramaState, defaultPhoto: props.defaultPanoramaPhoto }))] }));
}
exports.MapView = MapView;
